import { Cancel as CancelIcon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import { Button } from "@/components/core";

export function CancelButton({ label, onClick }: any) {
  const { t } = useTranslation("common");

  return (
    <Button variant="contained" color="warning" onClick={onClick} startIcon={<CancelIcon />}>
      {label || t("cancel")}
    </Button>
  );
}

CancelButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
};
